import { LOCALE_COUNTRY, LOCALE_LANGUAGE, SET_COUNTRY, SET_LANGUAGE } from '../constants/locale'
import { get, save } from '../services/storage'

export const setCountry = (countryId) => {
  save(LOCALE_COUNTRY, countryId)
  return {
    type: SET_COUNTRY,
    payload: countryId
  }
}

export const setLanguage = (language) => {
  save(LOCALE_LANGUAGE, JSON.stringify({
    id: language.id,
    slug: language.slug
  }))
  return {
    type: SET_LANGUAGE,
    payload: language
  }
}

export const loadLocale = () => {
  return (dispatch) => {
    const countryId = get(LOCALE_COUNTRY)
    if (countryId) {
      dispatch(setCountry(countryId))
    }
    try {
      const language = JSON.parse(get(LOCALE_LANGUAGE))
      if (language && language.id) {
        dispatch(setLanguage(language))
      }
    } catch (e) {}
  }
}
